import type { User } from 'shared/store/auth'
import { hasAdminPermission } from 'shared/lib/permissions/permissions'

export type DashboardCardKey =
	| 'createLot'
	| 'pendingTopups'
	| 'readyLots'
	| 'clients'
	| 'storefront'
	| 'settings'

export function getDashboardCardKeys(user: User): DashboardCardKey[] {
	const keys: DashboardCardKey[] = []
	if (hasAdminPermission(user, 'lots_admin', 'seller')) keys.push('createLot')
	if (hasAdminPermission(user, 'finance_admin')) keys.push('pendingTopups')
	if (hasAdminPermission(user, 'lots_admin', 'seller')) keys.push('readyLots')
	if (hasAdminPermission(user, 'finance_admin')) keys.push('clients')
	keys.push('storefront')
	if (hasAdminPermission(user)) keys.push('settings')
	return keys
}
